export const BUSINESS_HOURS =
    <span><span className="nowrap">Mon: 10AM - 6PM</span> | <span className="nowrap">Tue: 8:30AM - 6PM</span> | <span className="nowrap">Wed: 10AM - 6PM</span> | <span className="nowrap">Thur: 10AM - 7PM</span> | <span className="nowrap">Fri: 10AM - 6PM</span> | <span className="nowrap">Sat: 10AM - 2PM</span>
    </span>;

